import script from "./my-requests.vue?vue&type=script&setup=true&lang=js"
export * from "./my-requests.vue?vue&type=script&setup=true&lang=js"

import "./my-requests.vue?vue&type=style&index=0&id=49fa94bd&scoped=true&lang=css"
import "./my-requests.vue?vue&type=style&index=1&id=49fa94bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49fa94bd"]])

export default __exports__